import { StatusBadge } from '@repletoryreach/sdk-ui/data-display';
import { statusLabelKey, statusTone } from '../lib/status';
import { useT } from '../../../i18n/I18nProvider';

/**
 * Turn a status code into words. An unrecognised code is shown as it arrived,
 * which is honest and still readable, because the wire carries codes now
 * rather than the lookup row's id.
 */
export function useStatusLabel(): (status: string | null | undefined) => string {
  const t = useT();
  return (status) => {
    const key = statusLabelKey(status);
    if (key) return t(key);
    return status?.trim() ? status : t('common.unknown');
  };
}

/** The one status pill for the flow-runs list and every tab of a run. */
export function RunStatusBadge({ status, size = 'xs' }: { status: string | null | undefined; size?: 'xs' | 'sm' | 'md' }) {
  const label = useStatusLabel();
  return <StatusBadge status={statusTone(status)} size={size}>{label(status)}</StatusBadge>;
}
